import { useNavigate } from "react-router-dom";

export const ModalVendeLicor = ({ show, setShow }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1);
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="licores-modal-overlay">
      <div className="licores-modal-content">
        <button className="licores-close-button" onClick={handleClose}>&times;</button>
        <h2 className="licores-modal-title">¡Ups!</h2>
        <p className="licores-modal-message">
Esta máquina vende bebidas alcohólicas.
Para verificar tu edad y comprar, por favor utiliza la app móvil de Openmatic.</p>
        <button className="licores-btn-aceptar" onClick={handleClose}>Entendido</button>
      </div>
    </div>
    
  );
};
